export default {
  add_rate: 'Tarief toevoegen',
  remove_rate: 'Tarief verwijderen',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Elke betaalmethode',
    card: 'Kaart',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Pay by Bank',
    sepa_debit: 'SEPA-incasso',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Bacs-incasso',
    stripe_other: 'Overige Stripe-methoden',
  },
  fields: {
    percentage: 'Percentage',
    fixed: 'Vast bedrag',
    min: 'Minimumbedrag',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Op {{method}} wordt nog niets in rekening gebracht — deze betalingen leveren 0% marge op totdat een tarief is ingesteld.',
    floor_only: 'Op {{method}} bedraagt de transactiekosten {{floor}} per betaling, ongeacht het bestelbedrag.',
    percentage: 'Op {{method}} bedragen de transactiekosten {{percentage}}% van het bestelbedrag.',
    percentage_floor:
      'Op {{method}} bedragen de transactiekosten {{percentage}}% van het bestelbedrag, met een minimum van {{floor}}.',
    fixed: 'Op {{method}} bedragen de transactiekosten {{fixed}} per betaling.',
    fixed_floor: 'Op {{method}} bedragen de transactiekosten {{fixed}} per betaling, met een minimum van {{floor}}.',
    combined: 'Op {{method}} bedragen de transactiekosten {{fixed}} vast plus {{percentage}}% van het bestelbedrag.',
    combined_floor:
      'Op {{method}} bedragen de transactiekosten {{fixed}} vast plus {{percentage}}% van het bestelbedrag, met een minimum van {{floor}}.',
    redundant_floor:
      'Het minimum van {{floor}} heeft nooit effect — het vaste bedrag haalt dit al bij elke betaling. Stel het hoger in dan {{fixed}} of wis het.',
  },
  example: 'Voorbeeld: bij een bestelling van {{total}} bedragen de transactiekosten {{fee}}.',
};
